<template>
  <div class="grid-container sm:justify-center">
    <Head title="Crear perfil de empresa" />
    <div
      class="flex flex-col justify-center w-full pt-6 md:pt-14 sm:col-[3_/_-3] md:col-[5_/_-5] xl:col-[3_/_-3]"
    >
      <header class="flex flex-col gap-2">
        <h1 class="headline-sm md:headline-lg text-on-surface">
          Completa el perfil de la empresa
        </h1>
        <p class="title-md md:title-lg">
          Necesitamos que llenes unos datos generales para completar el perfil de tu empresa.
        </p>
      </header>
      <form class="pt-4" @submit.prevent="submitForm">
        <h2 class="title-lg text-on-primary-container py-2">Datos generales</h2>
        <TextInput
          id="company_name"
          v-model="form.name"
          label="Nombre de la Empresa"
          :error="errors.name"
          required
        />
        <FormTextarea
          id="description"
          v-model="form.description"
          label="Descripción"
          hint="Puedes incluir una breve descripción de las actividades que realizaste en tu institución"
          required
          :maxlength="300"
          :error="errors.description"
        />
        <FormSelect
          id="company_size"
          v-model="form.company_size_id"
          label="Tamaño"
          required
          :error="errors.company_size"
        >
          <option value="" disabled>Seleccionar</option>
          <option v-for="size in company_sizes" :key="size.id" :value="size.id">
            {{ size.name }} ({{ size.min_employee_count }} -
            {{ size.max_employee_count }} empleados)
          </option>
        </FormSelect>
        <FormSelect
          id="company_category"
          v-model="form.company_category_id"
          label="Rubro"
          required
          :error="errors.company_category"
        >
          <option value="" disabled>Seleccionar</option>
          <option v-for="category in company_categories" :key="category.id" :value="category.id">
            {{ category.name }}
          </option>
        </FormSelect>
        <h2 class="title-lg text-on-primary-container py-2">Misión, visión y valores</h2>
        <FormTextarea
          id="company_mission"
          v-model="form.company_mission"
          label="Misión"
          :maxlength="300"
          :error="errors.company_mission"
        />
        <FormTextarea
          id="company_vision"
          v-model="form.company_vision"
          label="Visión"
          :maxlength="300"
          :error="errors.company_vision"
        />
        <FormTextarea
          id="company_values"
          v-model="form.company_values"
          label="Valores"
          :maxlength="300"
          :error="errors.company_values"
        />
        <h2 class="title-lg text-on-primary-container py-2">Redes sociales</h2>
        <TextInput
          id="fb_url"
          v-model="form.fb_url"
          label="Facebook"
          placeholder="https://"
          icon="round-facebook"
          :error="errors.fb_url"
        />
        <TextInput
          id="linkedin_url"
          v-model="form.linkedin_url"
          label="LinkedIn"
          placeholder="https://"
          icon="linkedin"
          :error="errors.linkedin_url"
        />
        <TextInput
          id="website_url"
          v-model="form.website_url"
          label="Sitio web"
          placeholder="https://"
          icon="web"
          :error="errors.website_url"
        />
        <Button type="submit" class="btn-filled block mx-auto mt-4" :isLoading="form.processing"
          >Guardar</Button
        >
      </form>
    </div>
  </div>
</template>

<script>
import { cleanNullValuesFromObject } from '@/utilities.helpers.js'
import { Head } from '@inertiajs/inertia-vue'
import evalUserProfileType from '@/evalUserProfileType.mixin.js'
import Layout from '@/Layouts/Layout'
import Button from '@/Components/Button'
import TextInput from '@/Components/FormInputText'
import FormTextarea from '@/Components/FormTextarea'
import FormSelect from '@/Components/FormSelect'

export default {
  name: 'CompanyProfileCreate',
  layout: Layout,
  components: { Head, Button, TextInput, FormTextarea, FormSelect },
  mixins: [evalUserProfileType],
  props: {
    errors: Object,
    company: Object,
    company_sizes: Array,
    company_categories: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.company.name,
        description: this.company.description,
        company_mission: this.company.company_mission,
        company_vision: this.company.company_vision,
        company_values: this.company.company_values,
        website_url: this.company.website_url,
        fb_url: this.company.fb_url,
        linkedin_url: this.company.linkedin_url,
        company_size_id: this.company.company_size_id,
        company_category_id: this.company.company_category_id,
      }),
    }
  },
  methods: {
    submitForm() {
      this.form
        .transform(data => {
          return cleanNullValuesFromObject(data)
        })
        .put(this.$route('company.onboarding.profile.update'))
    },
  },
}
</script>
